import { hu } from './hu';
import { sk } from './sk';
import { gameSignals, type Locale } from '@/bridge/gameSignals';

type Dict = typeof hu;
type Key = keyof Dict | (string & {});

const DICTS: Record<Locale, Dict> = { hu, sk: sk as Dict };

function interpolate(s: string, vars?: Record<string, string | number>): string {
  if (!vars) return s;
  return s.replace(/\{(\w+)\}/g, (_, k: string) => (k in vars ? String(vars[k]) : `{${k}}`));
}

export function t(key: Key, vars?: Record<string, string | number>): string {
  const locale = gameSignals.currentLocale.value;
  const dict = DICTS[locale];
  const k = key as keyof Dict;
  let value: string | undefined = dict[k];
  if (value === undefined) {
    if (import.meta.env.DEV) console.warn(`[i18n] missing key: ${String(key)} (${locale})`);
    if (locale !== 'hu') value = hu[k];
    if (value === undefined) return String(key);
  }
  return interpolate(value, vars);
}

export function setLocale(next: Locale): void {
  gameSignals.currentLocale.value = next;
}
